import React from "react";
import styled from "styled-components";
import { ProductConsumer } from "../../Context/AddProWakel";
import addPro from "./../../img/add-product.png";
import sale from "./../../img/sale.png";
import store from "./../../img/store.png";
import raportyRozhana from "./../../img/raportyRozhana.png";
import Navbar from "../../Navbar/Navbar";
import wasl from "./../../img/wasl.png";
import chin from "./../../img/chin.png";

import { Link } from "react-router-dom";
const IpadCardList = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { D_OpenModal, L_user, role } = value;
          return (
            <>
              <Navbar />
              <div
                className="row "
                style={{ backgroundColor: "#2C3539" }}
              ></div>
              <div
                className="row mt2"
                style={{ backgroundColor: "#2C3539" }}
              ></div>
              <div
                className="row mt3"
                style={{ backgroundColor: "#2C3539" }}
              ></div>
              <div
                className="container mt4"
                style={{ backgroundColor: "#2C3539" }}
              >
                <ProductWraper
                  className="row"
                  style={{ backgroundColor: "#2C3539" }}
                >
                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/add-product">
                          <img
                            src={addPro}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">زیادکردنی کاڵا</p>
                      </div>
                    </div>
                  </div>

                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/ipad-rent">
                          <img
                            src={sale}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">فرۆشتن</p>
                      </div>
                    </div>
                  </div>

                  {/* bas */}
                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/take-money">
                          <img
                            src={wasl}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2"
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">پارەوەرگرتن</p>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer "
                    onClick={(e) => D_OpenModal(e, L_user._id)}
                  >
                    <div className="card ">
                      <div className="img-container p-5">
                        <img
                          src={raportyRozhana}
                          alt="product"
                          className="card-img-top "
                        />
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">ڕاپۆرتی ڕۆژانە</p>
                      </div>
                    </div>
                  </div>

                  {role == "ipadadmin" ? (
                    <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                      <div className="card ">
                        <div className="img-container p-5">
                          <Link to="/ipad-cin">
                            <img
                              src={chin}
                              alt="product"
                              className="card-img-top "
                            />
                          </Link>
                        </div>
                        <div
                          className="card-footer d-flex justify-content-center  h2"
                          style={{ color: "#2C3539" }}
                        >
                          <p className="align-self-center mb4 ">نرخی بنچینەی</p>
                        </div>
                      </div>
                    </div>
                  ) : null}

                  <div className="col-9 mx-auto col-md-6 col-lg-3 my-3 pointer">
                    <div className="card ">
                      <div className="img-container p-5">
                        <Link to="/ipad-garanawa">
                          <img
                            src={store}
                            alt="product"
                            className="card-img-top "
                          />
                        </Link>
                      </div>
                      <div
                        className="card-footer d-flex justify-content-center  h2 "
                        style={{ color: "#2C3539" }}
                      >
                        <p className="align-self-center mb4 ">
                          گەڕانەوە بۆ کۆگا
                        </p>
                      </div>
                    </div>
                  </div>
                </ProductWraper>
              </div>
              <div
                className="row mt4"
                style={{ backgroundColor: "#2C3539" }}
              ></div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

const ProductWraper = styled.div`
  .card {
    border-color: transparent;
    transition: all 1s linear;
  }

  .card-footer {
    background: transparent;
    border-top: transparent;
    transition: all 1s linear;
  }
  &:hover {
    .card {
      border: 0.04rem solid rgba(0, 0, 0, 0.2);
      box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.2);
    }

    .card-footer {
      background: rgba();
    }
  }
  .img-container {
    position: relative;
    overflow: hidden;
  }
  .card-img-top {
    transition: all 1s linear;
  }
  .img-container:hover .card-img-top {
    transform: scale(1.2);
  }
  .card-btn {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0.2rem 0.4rem;
    background: var(--lightBlue);
    border: none;
    color: var(--mainWhite);
    font-size: 1.4rem;
    border-radius: 0.5rem 0 0 0;
    transform: translate(100%, 100%);
    transition: all 1s linear;
  }
  .img-container:hover .card-btn {
    transform: translate(0, 0);
  }
  .card-btn:hover {
    color: var(--mainBlue);
    cursor: pointer;
  }
`;

export default IpadCardList;
